import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Hero        from './components/Hero';
import Second      from './components/Second';
import HeroTech    from './components/HeroTech';
import Technology  from './components/Technology';
import DataResults from './components/DataResults';
import ServiceFlow from './components/ServiceFlow';
import Pricing     from './components/Pricing';
import CaseStudies from './components/CaseStudies';
import Contact     from './components/Contact';
import Thanks      from './components/Thanks';

/* ─── LPのメインページ（全セクション） ─── */
function LpPage() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);

    const animateElements = document.querySelectorAll('.animate-on-scroll');
    animateElements.forEach(el => observer.observe(el));

    return () => {
      animateElements.forEach(el => observer.unobserve(el));
    };
  }, []);

  return (
    <div className="App">
      <Hero />
      <Second />
      <HeroTech />
      <Technology />
      <DataResults />
      <ServiceFlow />
      <Pricing />
      <CaseStudies />
      <Contact />
    </div>
  );
}

/* ─── ルーティング定義 ─── */
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"      element={<LpPage />} />
        <Route path="/thanks" element={<Thanks />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
